import { jsx as _jsx } from "react/jsx-runtime";
import makeBlockie from 'ethereum-blockies-base64';
import React, { useMemo } from 'react';
import { styled } from '../styled.js';
function Identicon(_ref) {
  let {
    address,
    className = '',
    size,
    style = {}
  } = _ref;
  const imgSrc = useMemo(() => makeBlockie(address), [address]);
  return _jsx(StyledImg, {
    className: className,
    size: size,
    src: imgSrc,
    style: style
  });
}
const StyledImg = styled.img(_ref2 => {
  let {
    size
  } = _ref2;
  return "\n  display: block;\n  height: ".concat(size, "px;\n  width: ").concat(size, "px;\n");
});
export const Ethereum = React.memo(Identicon);